import { render, staticRenderFns } from "./TheInstagramFeed.vue?vue&type=template&id=8de0c48e"
import script from "./TheInstagramFeed.vue?vue&type=script&lang=js"
export * from "./TheInstagramFeed.vue?vue&type=script&lang=js"
import style0 from "./TheInstagramFeed.vue?vue&type=style&index=0&id=8de0c48e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports